import React, { useEffect } from 'react';
import {
  CircularProgress,
  Alert,
} from '@mui/material';
import { type GridColDef } from '@mui/x-data-grid';
import { DataGrid, PageTitle, ListLayoutPanel, AddButton, GridEditButton } from '../../../components/common';
import { EditArticulo } from './components';
import { type Articulo, type ArticuloRequest } from './types/articulo';
import { useArticuloStore } from './store';

const ArticulosPage: React.FC = () => {
  const {
    articulos,
    loading,
    error,
    selectedArticulo,
    dialogOpen,
    fetchArticulos,
    saveArticulo,
    setSelectedArticulo,
    openDialog,
    closeDialog,
    clearError
  } = useArticuloStore();

  const columns: GridColDef[] = [
    { field: 'codigoArticulo', headerName: 'Código', width: 120 },
    { field: 'descripcion', headerName: 'Descripción', width: 250, flex: 1 },
    { field: 'marca', headerName: 'Marca', width: 150 },
    { field: 'modelo', headerName: 'Modelo', width: 150 },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 100,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,      
      align: 'center',
      renderCell: (params) => (
        <GridEditButton
          onClick={() => handleEdit(params.row.idArticulo)}
          ariaLabel={`Editar artículo ${params.row.descripcion}`}
        />
      ),
    },
  ];

  useEffect(() => {
    fetchArticulos();
  }, [fetchArticulos]);

  const handleEdit = (idArticulo: number) => {
    const articulo = articulos.find(a => a.idArticulo === idArticulo) || null;
    setSelectedArticulo(articulo);
    openDialog();
  };

  const handleCreate = () => {
    setSelectedArticulo(null);
    openDialog();
  };

  const handleClose = () => {
    closeDialog();
  };

  const handleSave = async (updatedArticulo: ArticuloRequest) => {
    try {
      await saveArticulo(updatedArticulo);
    } catch (error) {
      console.error('Error saving articulo:', error);
    }
  };

  if (loading) {
    return (
      <ListLayoutPanel>
        <PageTitle
          title="Artículos"
          subtitle="Gestión de artículos"
          actions={
            <AddButton
              text="Nuevo Artículo"
              onClick={handleCreate}
            />
          }
        />
        <CircularProgress />
      </ListLayoutPanel>
    );
  }

  if (error) {
    return (
      <ListLayoutPanel>
        <PageTitle
          title="Artículos"
          subtitle="Gestión de artículos"
          actions={
            <AddButton
              text="Nuevo Artículo"
              onClick={handleCreate}
            />
          }
        />
        <Alert
          severity="error"
          onClose={clearError}
        >
          {error}
        </Alert>
      </ListLayoutPanel>
    );
  }

  return (
    <ListLayoutPanel>
      <PageTitle
        title="Artículos"
        subtitle="Gestión de artículos"
        actions={
          <AddButton
            text="Nuevo Artículo"
            onClick={handleCreate}
          />
        }
      />

      <DataGrid
        columns={columns}
        rows={articulos}
        getRowId={(row: Articulo) => row.idArticulo}
      />

      <EditArticulo
        open={dialogOpen}
        articuloIdArticulo={selectedArticulo?.idArticulo || null}
        onClose={handleClose}
        onSave={handleSave}
        title={selectedArticulo ? "Editar Artículo" : "Nuevo Artículo"}
      />
    </ListLayoutPanel>
  );
};

export default ArticulosPage;